import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { PermissionService } from 'src/app/core/services/permission.service';

@Directive({ selector: '[appHasPermission]' })
export class HasPermissionDirective implements OnInit {
    @Input('appHasPermission') permissionKey!: string;

    constructor(
        private tpl: TemplateRef<any>,
        private vc: ViewContainerRef,
        private permSvc: PermissionService
    ) { }

    ngOnInit() {
        this.vc.clear();

        if (this.permSvc.hasPermission(this.permissionKey) || !this.permissionKey) {
            this.vc.createEmbeddedView(this.tpl);
        }
    }
}
